import script from "./base-checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./base-checkbox.vue?vue&type=style&index=0&id=46b1be6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b1be6e"]])

export default __exports__